import {
  isEmpty,
  validateEmail,
  validateFileType,
  validateFullName,
  validateLength,
  validateName,
  validatePhone,
} from '../../../utility/validation';
import { FIELD_TYPES } from '../../../constants/fieldTypes';

const { TEXT, CHECKBOX, UPLOAD_FILE } = FIELD_TYPES;

export const APPLY_JOB_FIELD_NAMES = {
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  FULL_NAME: 'full_name',
  EMAIL: 'email',
  PHONE: 'phone',
  CV: 'cv',
  TERMS_ACCEPTED: 'terms_accepted',
};

export const INITIAL_APPLY_JOB_DATA = {
  [APPLY_JOB_FIELD_NAMES.FULL_NAME]: '',
  [APPLY_JOB_FIELD_NAMES.EMAIL]: '',
  [APPLY_JOB_FIELD_NAMES.PHONE]: '',
  [APPLY_JOB_FIELD_NAMES.CV]: null,
  [APPLY_JOB_FIELD_NAMES.TERMS_ACCEPTED]: false,
};

export const getApplyJobFields = () => [
  {
    name: APPLY_JOB_FIELD_NAMES.FULL_NAME,
    translationKey: 'fullName',
    type: TEXT,
    required: true,
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
      {
        validator: validateName,
        type: 'invalidName',
      },
      {
        validator: validateFullName,
        type: 'invalidFullName',
      },
      {
        validator: value => validateLength(value, 2, undefined, true),
        type: 'minLength',
      },
      {
        validator: value => validateLength(value, 0, 255),
        type: 'inputMaxLength',
      },
    ],
  },
  {
    name: APPLY_JOB_FIELD_NAMES.EMAIL,
    translationKey: 'email',
    type: TEXT,
    required: true,
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
      {
        validator: value => validateEmail(value),
        type: 'invalidEmail',
      },
      {
        validator: value => validateLength(value, 0, 100),
        type: 'exceededLengthEmail',
      },
    ],
  },
  {
    name: APPLY_JOB_FIELD_NAMES.PHONE,
    translationKey: 'phone',
    type: TEXT,
    required: true,
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
      {
        validator: validatePhone,
        type: 'invalidPhone',
      },
    ],
  },
  {
    name: APPLY_JOB_FIELD_NAMES.CV,
    translationKey: 'resume',
    type: UPLOAD_FILE,
    required: true,
    isMultiple: false,
    types: {
      'application/pdf': ['.pdf'],
    },
    validators: [
      {
        validator: isEmpty,
        type: 'required',
      },
      {
        type: 'fileType',
        validator: value => validateFileType(value, 'application/pdf'),
      },
      {
        validator: value => validateLength(value?.name, 0, 100),
        type: 'fileLength',
      },
    ],
  },
  {
    name: APPLY_JOB_FIELD_NAMES.TERMS_ACCEPTED,
    translationKey: 'termsAccepted',
    type: CHECKBOX,
  },
];

export const splitFullName = fullName => {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) {
    return { first_name: '', last_name: '' };
  }

  if (parts.length === 1) {
    return { first_name: parts[0], last_name: '' };
  }

  return {
    first_name: parts[0],
    last_name: parts.slice(1).join(' '),
  };
};
